/*
 * vueのpagerコンポーネント
 */

const template = `<div v-if="hasPages" class="pager">
	<div class="pager__inner">
		<a v-show="hasPrev" class="pager__prev" v-on:click="prev">前へ</a>
		<a v-for="page of max" class="pager__num" :aria-current="isCurrent(page) ? 'true' : false" v-on:click="change(page)" v-text="page"></a>
		<a v-show="hasNext" class="pager__next" v-on:click="next">次へ</a>
	</div>
</div>`

const Pager = Vue.component('v-pager', {
	template: template,
	props: {
		total: {
			type: Number,
			default: 0
		},
		perpage: {
			type: Number,
			default: 20
		},
		current: {
			type: Number,
			default: 1
		}
	},
	computed: {
		max () {
			return Math.ceil(this.total / this.perpage)
		},
		hasPages () {
			return this.max >= 2
		},
		hasNext () {
			return this.current < this.max
		},
		hasPrev () {
			return this.current > 1
		},
	},
	methods: {
		change (page) {
			if (page < 1 ||  page > this.max || page === this.page) {
				return
			}
			this.$emit('change', page)
		},
		next () {
			this.change(this.current + 1)
		},
		prev () {
			this.change(this.current - 1)
		},
		isCurrent (page) {
			return page === this.current
		}
	}
})

export default Pager